export function parseCommaSeparated(value) {
  return value.split(",").map(name => name.trim()).filter(name => name.length > 0);
}